export default __webpack_public_path__ + "static/media/professional_cleaning.414fdb5c.png";